import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.1",
      d: "M10 15.082a6.4 6.4 0 1 0 0-12.8 6.4 6.4 0 0 0 0 12.8Z"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "9.999",
      cy: "13.3",
      fill: "currentColor",
      rx: "1.2",
      ry: ".3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.73 16.445c-.11.12-.231.222-.353.304l-.078.053-.086.037a.35.35 0 0 0-.187.205c-.082.221.038.435.195.498 1.036.412 2.353.654 3.779.654s2.743-.243 3.779-.654c.157-.063.277-.277.194-.498a.35.35 0 0 0-.186-.205l-.087-.037-.078-.053a2 2 0 0 1-.352-.304 8.1 8.1 0 0 1-3.27.686 8.1 8.1 0 0 1-3.27-.686"
    }, null, -1)
  ])))
}
export default { render: render }